import React from "react";
import CounterCard from "../../../../../../components/Molecules/Card/CounterCard/CounterCard";
import SelectCard from "../../../../../../components/Molecules/Card/SelectCard/SelectCard";
import { verifyStatus } from "../../../../../../helpers/customizedItem/customizedItem.helper";
import * as Constants from "../../../../../../constants";
import { IItemModifierGroups } from "../../../../../../models/try2Combo";

const ItemModifierGroups: React.FC<IItemModifierGroups> = (props) => {
  const {
    ingredients,
    selectedAddOns,
    selectedCore,
    handleClick,
    isLimitExceed,
    isItEdit,
    noGrid,
    showCustomization,
    itemModifierItemModalWidth,
    upsellStylesClass,
    upsellCardPadding,
    isCreateYourOwnItem
  } = props;

  const selectedCoreModifier = (ingredient) => {
    return selectedCore.find(
      (selected) => selected.modifier_id === ingredient.id
    );
  };

  const selectedAddonsModifier = (ingredient) => {
    return selectedAddOns.find(
      (selected) =>
        selected.modifier_id === ingredient.id &&
        selected.modifier_group_id === ingredient.modifier_group_id &&
        !selected.core
    );
  };

  const selectedModifier = (ingredient) => {
    let selectedSide = selectedAddonsModifier(ingredient);
    if (!selectedSide) {
      selectedSide = selectedCoreModifier(ingredient);
    }
    return selectedSide;
  };

  const modifierGroupLabels = (
    selectedSide: any,
    extendable_limit: number,
    groupMin: number
  ) => {
    if (extendable_limit === 1 && groupMin === 1) {
      return selectedSide ? "Included" : "include";
    } else {
      return undefined;
    }
  };

  return (
    <>
      {ingredients?.modifiers_groups_modifiers.map(
        (ingredient, index: number) => {
          let selectedSide = selectedModifier(ingredient);
          return (
            <React.Fragment key={index}>
              <div
                className={`${
                  noGrid ? "item__modifier_item" : "py-md-3 col-4 col-sm-3"
                } ${itemModifierItemModalWidth} ${upsellStylesClass}`}
              >
                {ingredient.max > 1 ? (
                  <CounterCard
                    id={ingredient.id}
                    brink_id={ingredient.brink_modifier_id}
                    default_selected={ingredient.is_selected}
                    image={`${Constants.REACT_APP_CLOUD_FRONT}${ingredient.image}`}
                    title={ingredient.name}
                    calories={ingredient.calories}
                    price={ingredient.price}
                    is_active={verifyStatus(
                      ingredient,
                      Constants.MODIFIER_LOCATION
                    )}
                    priceAlternateLabel={modifierGroupLabels(
                      selectedSide,
                      ingredients.extendable_limit,
                      ingredients.min
                    )}
                    handleClick={(data) => {
                      handleClick(data, ingredients, Constants?.ADD_ONS);
                    }}
                    max={ingredient.max}
                    groupMin={ingredients.min}
                    count={selectedSide?.quantity || 0}
                    isApplyDisable={true}
                    additionalPrice={selectedSide?.additionalPrice}
                    extendableLimit={isLimitExceed(
                      ingredients.id,
                      ingredients.extendable_limit,
                      ingredients.min
                    )}
                    extendableLimitValue={ingredients.extendable_limit}
                    isItEdit={showCustomization}
                    upsellCardPadding={upsellCardPadding}
                    isCreateYourOwnItem={isCreateYourOwnItem}
                  />
                ) : (
                  <SelectCard
                    id={ingredient?.id}
                    brink_id={ingredient?.brink_modifier_id}
                    default_selected={ingredient.is_selected}
                    image={`${Constants.REACT_APP_CLOUD_FRONT}${ingredient.image}`}
                    title={ingredient.name}
                    price={ingredient.price}
                    calories={ingredient.calories}
                    is_active={verifyStatus(
                      ingredient,
                      Constants.MODIFIER_LOCATION
                    )}
                    handleClick={(data) => {
                      handleClick(data, ingredients, Constants?.ADD_ONS);
                    }}
                    priceAlternateLabel={modifierGroupLabels(
                      selectedSide,
                      ingredients.extendable_limit,
                      ingredients.min
                    )}
                    groupMin={ingredients.min}
                    selected={Boolean(selectedSide)}
                    modifierAdditionalPrice={selectedSide?.additionalPrice}
                    extendableLimit={isLimitExceed(
                      ingredients.id,
                      ingredients.extendable_limit,
                      ingredients.min
                    )}
                    extendableLimitValue={ingredients.extendable_limit}
                    isItEdit={isItEdit}
                    showCustomization={showCustomization}
                    upsellCardPadding={upsellCardPadding}
                    isCreateYourOwnItem={isCreateYourOwnItem}
                  />
                )}
              </div>
            </React.Fragment>
          );
        }
      )}
    </>
  );
};

export default ItemModifierGroups;
